<template>
  <div class="takecash">
    <header class="takecash-top">
      <div @click="goDetail">
        <div>
          <i
            class="iconfont icon-svgmoneybag"
            aria-hidden="true"
            style="font-size: 70px; color: #feb70f"
          ></i>
        </div>
        <p class="takecash-total">
          <span>￥{{ money.toFixed(1) }}</span> 元
        </p>
      </div>
      <p style="margin-top: 10px" @click="takecashList">
        <a href="javascript:;" style="color: blue">查看提现记录 &gt;&gt;</a>
      </p>
    </header>
    <section class="takecash-main">
      <section class="mail-tips">
        <span style="font-size: 14px; font-weight: bold">提现须知</span>
        <p style="font-size: 12px">
          每天最多可以提现10次，单笔单日限额2万/2万元，1分钟允许提交一次申请，温馨提示：提现收取0.6%的手续费，系统处理完成后将发放到您的微信钱包中。
        </p>
      </section>
      <div class="weui-cells weui-cells_form" style="margin-top: 0px">
        <div class="weui-cell weui-cell_vcode">
          <div class="weui-cell__hd">
            <label class="weui-label">提现金额</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              placeholder="提现金额>=1元"
              v-model="takecash"
              style="text-align: right"
            />
          </div>
          <div class="weui-cell__ft">
            <button class="weui-vcode-btn">
              <font>元</font>
            </button>
          </div>
        </div>
      </div>

      <div
        class="footer-item able"
        style="flex: 2"
        v-if="money > 0"
        @click="apply"
      >
        <a href="javascript:;">提交提现申请</a>
      </div>
      <div class="footer-item disable" style="flex: 2" v-if="money == 0">
        <a href="javascript:;">提交提现申请</a>
      </div>
    </section>
  </div>
</template>
<script>
import moment from "moment";
import weui from "weui.js";
import axios from "axios";

export default {
  data() {
    return {
      money: 0,
      takecash: "",
      encodeToken: "",
      token: "",
      year: moment().format("YYYY"),
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then((response) => {
        let userInfo = response.data.data;
        if (userInfo.money) {
          this.money = userInfo.money / 100;
        }
      })
      .catch((error) => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    goDetail() {
      this.$router.push("/moneyDetail/0/" + this.encodeToken);
    },
    takecashList() {
      this.$router.push("/takecashList/" + this.encodeToken);
    },
    apply() {
      let that = this;
      if (!this.takecash) {
        weui.alert("请输入您的提现金额");
        return;
      } else if (this.takecash > this.money) {
        weui.alert("提现金额不能大于余额");
        return;
      } else if (this.takecash < 1 || this.takecash > 5000) {
        weui.alert("提现金额必须>=1 并且 <=5000");
        return;
      } else {
        weui.confirm(
          "确认要提交提现申请？",
          function () {
            axios
              .post("/api/takecash", { money: that.takecash * 100 })
              .then((res) => {
                if (res.data.success) {
                  that.money -= parseFloat(that.takecash);
                  that.takecash = "";
                  weui.toast("申请成功");
                } else {
                  that.takecash = "";
                  setTimeout(function () {
                    weui.alert(res.data.message);
                  }, 1000);
                }
              })
              .catch((err) => {
                console.log(err);
                that.takecash = "";
                weui.alert("提现失败，请联系系统管理员");
              });
          },
          function () {}
        );
      }
    },
  },
};
</script>
<style scoped>
.takecash {
  margin-top: 40px;
  font-size: 16px;
}
.takecash-top {
  text-align: center;
}
.takecash-top .fa-money {
  font-size: 90px;
}
.takecash-total {
  font-size: 24px;
  color: orangered;
}
.takecash-main {
  margin-top: 30px;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
.footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  line-height: 50px;
}
.footer-item.able {
  background-color: #feb70f;
}
.footer-item.disable {
  background-color: grey;
}
.footer-item a {
  color: #ffffff;
}
.weui-footer {
  position: fixed;
  bottom: 10px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/TakeCash.vue